<form class="gap-lg grid" [formGroup]="form()">
  <div hlmField>
    <label hlmFieldLabel for="nom-etape" labelRequired>Nom de l'étape</label>
    <input id="nom-etape" hlmInput type="text" formControlName="nom" />
    @if (nom.hasError('required')) {
      <hlm-field-error>Le nom de l'étape est obligatoire</hlm-field-error>
    } @else {
      <p hlmFieldDescription>L'étape sera numérotée par défaut.</p>
    }
  </div>

  <div hlmField>
    <label class="text-components-content-neutral-quaternary" hlmFieldLabel for="code-etape"
      >Code étape <span class="component-small-medium">- Requis</span></label
    >
    <input id="code-etape" hlmInput type="text" formControlName="code" readonly />
    <p
      [class]="{
        'text-danger': form().get('code')?.invalid,
        'text-components-content-neutral-quaternary': form().get('code')?.valid,
      }"
      hlmFieldDescription
    >
      Rempli automatiquement.
      @if (form().get('code')?.invalid && form().get('certification')?.value !== undefined) {
        <span>La certification choisie ne permet pas de générer un code valide. (Ex: niveau absent ..)</span>
      }
    </p>
  </div>

  <div hlmField>
    <label class="text-components-content-neutral-quaternary" hlmFieldLabel for="code-ancien-etape"
      >Ancien code étape <span class="component-small-medium">- Requis</span></label
    >
    <input id="code-ancien-etape" hlmInput type="text" formControlName="ancienCode" readonly />
    <p class="text-components-content-neutral-quaternary" hlmFieldDescription>
      Si cette étape remplace une ancienne étape.
    </p>
  </div>

  <div class="gap-xs grid">
    <span
      [class]="{
        'text-components-content-neutral-quaternary': form().disabled,
      }"
      hlmFieldLabel
      >Gestion</span
    >
    <div class="gap-md grid">
      <label class="component-medium-medium flex items-center" hlmLabel>
        <hlm-switch
          [checked]="estALaCarte.value"
          [disabled]="form().disabled"
          (checkedChange)="handleEstALaCarteChange()"
        />
        Passer l’étape dans un groupe « à la carte ».
      </label>

      @if (estALaCarte.value) {
        @if (groupes().length) {
          <hlm-select multiple formControlName="groupes">
            <hlm-select-trigger>
              <hlm-select-value />
            </hlm-select-trigger>
            <hlm-select-content>
              @for (groupe of groupes(); track groupe.id) {
                <hlm-option [value]="groupe.id">
                  {{ groupe.nom }}
                </hlm-option>
              }
            </hlm-select-content>
          </hlm-select>
        } @else {
          <app-alerte>
            <p class="component-medium-medium">
              Aucun groupe n’est disponible. Créez d’abord un
              <span class="component-medium-semibold">groupe d’étapes à la carte</span> sur le canvas (clic droit) pour
              y assigner cette étape.
            </p>
          </app-alerte>
        }
      }
    </div>
  </div>

  <div class="gap-xs grid">
    <span
      [class]="{
        'text-components-content-neutral-quaternary': form().disabled,
      }"
      hlmFieldLabel
      >Paramètres</span
    >
    <div class="gap-md grid">
      <label class="component-medium-medium flex items-center" hlmLabel>
        <hlm-switch formControlName="aCursusInternational" /> L'étape peut être suivie d'un cursus international
      </label>
      <label class="component-medium-medium flex items-center" hlmLabel>
        <hlm-switch formControlName="aChangementVille" /> L'étape doit être suivie d'un changement de ville
      </label>
    </div>
  </div>
</form>
